import { Component } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import LoginForm from "../components/loginform";

class Login extends Component {
    constructor() {
        super();
        this.state = {
            login: false
        }
    }

    updateLogin(lo = false) {
        this.setState({login: lo});
        window.location.href = "/dashy";
    }
    
    render() {
        var ul = this.updateLogin;
        return <>
        <Header />
            <main className="container">
                <div className="row">
                    <LoginForm updateLogin={ul.bind(this)} />
                </div>
            </main>
        <Footer />
        </>
    }
}

export default Login;